export default __webpack_public_path__ + "static/media/icon.18687a6e.png";